import { ReactNode } from 'react';

import { SidebarInset, SidebarProvider } from '../../ui/sidebar-cn';

import { AppSidebar } from './app-sidebar';

interface IAppSidebarLayoutProps {
  children: ReactNode;
  defaultOpen: boolean;
}

/**
 * -----------------------------------------------------------------------------
 * This provides the base building block of the application sidebar layout that
 * is to be used by all pages within the `(app)` grouping
 */
export async function AppSidebarLayout({
  children,
  defaultOpen,
}: IAppSidebarLayoutProps) {
  return (
    <SidebarProvider defaultOpen={defaultOpen}>
      <AppSidebar />

      <SidebarInset>{children}</SidebarInset>
    </SidebarProvider>
  );
}
